import { getNumberString } from 'utils/common';

import { ICashierSettings, ICashierSettingsData } from './types';

export const normalizeCashierSettings = (
  data: ICashierSettingsData,
): ICashierSettings => {
  return {
    amountInputDecimalSeparator: (data?.amountInputDecimalSeparator as string) || null,
    amountInputThousandsSeparator:
      (data?.amountInputThousandsSeparator as string) || null,
    amountTextDecimalSeparator: (data?.amountTextDecimalSeparator as string) || null,
    amountTextThousandsSeparator: (data?.amountTextThousandsSeparator as string) || null,
    cashierPaymentMethod: {
      isCashierPaymentMethod: !!data?.cashierPaymentMethod?.isCashierPaymentMethod,
      name: (data?.cashierPaymentMethod?.name as string) || '',
      paymentMethod: (data?.cashierPaymentMethod?.paymentMethod as string) || '',
    },
    commission: data?.commission as number,
    commissionConfirmation: !!data?.commissionConfirmation,
    currency: (data?.currency as string) || '',
    currencySymbolOverride: (data?.currencySymbolOverride as string) || null,
    defaultAmount: getNumberString(data?.defaultAmount as number) as string,
    earlyRouting: !!data?.earlyRouting,
    enableCurrencyPositionAfter: !!data?.enableCurrencyPositionAfter,
    enableCurrencySymbolOverride: !!data?.enableCurrencySymbolOverride,
    enablePromoCode: !!data?.enablePromoCode,
    id: (data?.id as number) || 0,
    ignoreCardholder: !!data?.ignoreCardholder,
    ignoreCvv: !!data?.ignoreCvv,
    merchantTerminal: {
      id: (data?.merchantTerminal?.id as number) || 0,
      merchant: {
        id: (data?.merchantTerminal?.merchant?.id as number) || 0,
        name: (data?.merchantTerminal?.merchant?.name as string) || '',
      },
      name: (data?.merchantTerminal?.name as string) || '',
    },
    minCommission: data?.minCommission as number,
    onlyRoundAmount: !!data?.onlyRoundAmount,
    predefinedAmounts: {
      amount1: getNumberString(data?.predefinedAmounts?.amount1 as number) as string,
      amount2: getNumberString(data?.predefinedAmounts?.amount2 as number) as string,
      amount3: getNumberString(data?.predefinedAmounts?.amount3 as number) as string,
    },
    requestAccountId: !!data?.requestAccountId,
    requestCardPan: !!data?.requestCardPan,
    requiredFields: {
      address1: !!data?.requiredFields?.address1,
      address2: !!data?.requiredFields?.address2,
      city: !!data?.requiredFields?.city,
      countryCode: !!data?.requiredFields?.countryCode,
      currency: !!data?.requiredFields?.currency,
      dateOfBirth: !!data?.requiredFields?.dateOfBirth,
      email: !!data?.requiredFields?.email,
      firstName: !!data?.requiredFields?.firstName,
      gender: !!data?.requiredFields?.gender,
      lastName: !!data?.requiredFields?.lastName,
      personalId: !!data?.requiredFields?.personalId,
      phone: !!data?.requiredFields?.phone,
      phoneCountryCode: !!data?.requiredFields?.phoneCountryCode,
      postCode: !!data?.requiredFields?.postCode,
      state: !!data?.requiredFields?.state,
    },
    transactionType: (data?.transactionType as string) || '',
  };
};
